import React, { Component } from "react";
import Slider from "react-slick";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../Banner/style.css";
class TopBanner extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      dataSource: [],
      css: {
        topSlider: {
          width: 710,
          height: 240,
          borderRadius: 5,
        },
        img: {
          height: 240,
        },
      },
    };
  }
  componentWillMount() {
    this.requestTopBanner();
  }
  componentDidMount() {
    this.fixCSS();
    window.addEventListener("resize", () => {
      this.fixCSS();
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this._resizeListener);
    clearTimeout(this.timeouter);
    this.setState = (state, callback) => {
      return;
    };
  }
  render() {
    const settings = {
      dots: true,
      arrow: false,
      slidesToShow: 1,
      swipeToSlide: true,
      autoplay: true,
    };
    const { dataSource } = this.state;
    return (
      <div style={this.state.css.topSlider} className="topSlider">
        <Slider {...settings}>
          {dataSource.map((item, index) => {
            return (
              <div
                onClick={() => this.handleJump(item.isJump, item.jumpLink)}
                key={index}
              >
                <img alt="" style={this.state.css.img} src={item.imgUrl}></img>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }

  /**
   * 请求TopBanner的数据 type类型为1
   */
  requestTopBanner() {
    get("/public/v1/home/banner/1").then((res) => {
      this.setState({
        dataSource: res.data,
      });
    });
  }

  /**
   * 轮播图跳转链接
   */
  handleJump = (isJump, jumpLink) => {
    if (isJump === 1) {
     // window.location = jumpLink;
      //window.open(jumpLink);
      window.location.href = jumpLink +'?timestamp='+ new Date().getTime()+Math.random();
    }
  };

  fixCSS = () => {
    let clientWidth = document.body.clientWidth;
    let ratio = 1;
    if (clientWidth < 750) {
      ratio = clientWidth / 750;
    }
    this.setState({
      css: {
        topSlider: {
          width: 710 * ratio,
          height: 240 * ratio,
          borderRadius: 5,
        },
        img: {
          height: 240 * ratio,
        },
      },
    });
  };
}

export default TopBanner;



// WEBPACK FOOTER //
// ./src/containers/Home/components/Banner/TopBanner/index.js